<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="warning"
        fab
        title="Edit Priority"
        v-on="on"
      >
        <v-icon medium>
          mdi-format-line-spacing
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Item
            </h4>
            <p class="category font-weight-thin">
              Edit Fund Bucket Item Priority
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-container>
        <v-form
          v-if="dialog && !loading"
          lazy-validation
        >
          <div v-if="!show">
            <v-combobox
              v-model="form.schemas"
              v-validate="'required'"
              label="Schema"
              multiple 
              :items="schemas"
              item-text="schema_name"
              item-value="schema_name"
              value="schema_name"
              :return-object="false"
              :error-messages="errors.collect('schema')"
              data-vv-name="schema"
            />
            <v-combobox
              v-model="form.group"
              v-validate="'required'"
              label="Group"
              :items="filteredGroups"
              item-text="fund_bucket.group"
              item-value="fund_bucket.group"
              :error-messages="errors.collect('group')"
              :return-object="false"
              data-vv-name="group"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="loadPriorityData"
              >
                Go
              </v-btn>
            </v-card-actions>
            <v-alert
              v-if="warning"
              type="warning"
              dense
              class="mt-5"
            >
              {{ warningMessage }}
            </v-alert>
          </div>

          <div 
            v-else
            class="overflow"
            data-simplebar
          >
            <v-simple-table
              dense
              class="mb-5 mt-5"
              style="border:2px solid #c5c5c5;border-radius:5px;padding:10px"
            >
              <template>
                <thead>
                  <tr class="grey lighten-1">
                    <th style="width:10px">
                      ID
                    </th>
                    <th style="width:161px">
                      Company Name
                    </th>
                    <th style="width:161px">
                      Description
                    </th>
                    <th
                      class="text-center"
                      style="width:120px"
                    >
                      Current Priority
                    </th>
                    <th
                      class="text-center"
                      style="width:114px"
                    >
                      New Priority
                    </th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  ghost-class="ghost"
                  @end="dragReorder"
                >
                  <tr
                    v-for="item in recordsFound"
                    :key="itemKey(item)"
                    class="sortableRow sortHandle handle"
                  >
                    <td>{{ item.id }}</td>
                    <v-hover v-slot:default="{ hover }">
                      <td>
                        {{ item.company.name }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            {{ item.otherCompany }}
                          </div>
                        </v-expand-transition>
                      </td>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                      <td>
                        {{ item.fund_bucket_item_descriptions.description }}
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class=" transition-fast-in-fast-out v-card--reveal"
                          >
                            {{ item.otherDescription }}
                          </div>
                        </v-expand-transition>
                      </td>
                    </v-hover>

                    <td class="text-center">
                      {{ item.priority }}
                    </td>

                    <td class="text-center">
                      {{ item.newPriority=orderNumber(item) }}
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-simple-table>
                        
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="back"
              >
                Back
              </v-btn>
              <v-btn
                color="success"
                @click="priorityUpdate"
              >
                Replace
              </v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  // import Sortable from 'sortablejs'
  import draggable from 'vuedraggable'

  export default {
    inject: ['$validator'],
    components: {
      draggable,
    },
    data: () => ({
      itemKeys: new WeakMap(),
      currentItemKey: 0,

      dialog: false,
      loading: false,
      show: false,
      warningMessage: '',
      warning: false,
      form: {
        schemas: '',
        group: '',
      },

      allIds: [],

      recordsFound: [],
      schemas: [],
      fundBucketHasTypes: [],
    }),
    computed: {
      filteredGroups () {
        if (this.form.schemas.length === 0) return
        
        return this.fundBucketHasTypes.filter(fundBucketHasType => {
          const schema = fundBucketHasType.schema_name

          return _.union([schema], this.form.schemas).length === this.form.schemas.length
        })
      },
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
    },

    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().withSchema(),
          this.$api.fundBucketHasTypes().list(),
        ]).then(([schemas, fundBucketHasTypes]) => {
          this.schemas = schemas.data
          this.fundBucketHasTypes = fundBucketHasTypes.data
          this.loading = false
        })
      },
      itemKey (item) {
        if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
        return this.itemKeys.get(item)
      },

      dragReorder ({ oldIndex, newIndex }) {
        const movedItem = this.recordsFound.splice(oldIndex, 1)[0]
        this.recordsFound.splice(newIndex, 0, movedItem)
      },

      orderNumber (item) {
        return this.recordsFound.indexOf(item) + 1
      },
      loadPriorityData () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.$api.fundBucketItems().priorityIds(this.formData())
              .then((response) => {
                this.allIds = response.data

                if (response.data) {
                  this.show = true
                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].length) {
                      this.recordsFound = response.data[i].sort(function (a, b) {
                        return a.priority - b.priority
                      })
                      break
                    }
                  }

                  for (let i = 1; i < response.data.length; i++) {
                    response.data[0].map(item => {
                      item.otherCompany = ''
                      item.otherDescription = ''

                      response.data[i].map(x => {
                        if (item.company_id !== x.company_id && item.priority === x.priority) {
                          item.otherCompany += '- ' + x.company.name + '\n'
                          if (item.description_id !== x.description_id) {
                            item.otherDescription += '- ' + x.fund_bucket_item_descriptions.description + '\n' 
                          }
                        }
                      })
                    })
                  }

                  for (let i = 1; i < response.data.length; i++) {
                    if (response.data[0].length !== response.data[i].length) {
                      this.warningMessage = 'Array length is different / Description is different!'
                      this.warning = true
                    }
                  }

                  // eslint-disable-next-line no-new
                  // new Sortable(
                  //   document.querySelector('#dragTable'),
                  //   {
                  //     draggable: '.sortableRow',
                  //     handle: '.sortHandle',
                  //     onEnd: this.dragReorder,
                  //   },
                  // )
                } else {
                  this.$snack({
                    color: 'error',
                    message: 'No record found',
                  })
                }
              }).catch((err) => {
                console.log(err)
                this.$snack({ color: 'error', message: err.response.statusText })
              })
          })
      },
      formData () {
        return {
          schema: this.form.schemas,
          group: this.form.group,
        }
      },
      priorityUpdate () {
        this.$api.fundBucketItems().priorityUpdate(this.updateForm())
          .then(response => {
            if (response.status === 200) {
              this.$emit('updated')
              this.$snack({ message: response.data.message })

              this.dialog = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      updateForm () {
        return {
          records: this.allIds,
        }
      },
      back () {
        this.show = false
        this.warning = false
      },
    },
  }
</script>

<style scoped>
    .text-center{
        text-align: center;
    }

    .handle {
        cursor: move;
    }

    tbody tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, 0.01);
    }
    
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, 0.05);
    }

    tbody tr:hover {
        background-color: #ffff99 !important;
    }

    .overflow {
      height: 60vh;
      overflow-x: hidden;
    }

    .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
       background-image: linear-gradient( grey , grey);
    }
</style>
